import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardOrganizationSummaryFormatQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_ORGANIZATION_LOADER } from "@application/loaders/dashboard_organization_loader";
import { DASHBOARD_ORGANIZATION_SUMMARY_FORMAT_LOADER } from "@application/loaders/dashboard_organization_summary_format_loader";

import { DASHBOARD_ORGANIZATIONS_LINK } from "@application/navigation/dashboard_organizations_link";

import { Loader } from "@styled/loader";

import { summaryFormatPath } from "./organization_summary_format_controls";

const DashboardOrganizationsList = lazy(() =>
  import("./organizations_list").then((m) => ({
    default: m.DashboardOrganizationsList,
  })),
);

const DashboardOrganizationSummaryFormat = lazy(() =>
  import("./summary_format/summary_format_page").then((m) => ({
    default: m.DashboardOrganizationSummaryFormat,
  })),
);

// The index is Builder → Organizations (master org only); `:id` is the
// org switcher (a loader that swaps the active org and redirects), so an
// org's own screens sit beside it, never under it.
export const DASHBOARD_ORGANIZATIONS_ROUTE = {
  path: "organizations",
  handle: DASHBOARD_ORGANIZATIONS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardOrganizationsList />
        </Suspense>
      ),
    },
    {
      path: ":id",
      loader: DASHBOARD_ORGANIZATION_LOADER,
    },
    {
      path: ":id/summary-format",
      loader: DASHBOARD_ORGANIZATION_SUMMARY_FORMAT_LOADER,
      handle: (data: DashboardOrganizationSummaryFormatQuery): Breadcrumb => ({
        name: "Summary format",
        to: summaryFormatPath(data.pushableOrganization.id),
      }),
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardOrganizationSummaryFormat />
        </Suspense>
      ),
    },
  ],
} satisfies RouteObject;
